<template>
  <div class="user-card__header">
    <div class="user-ident">
      <div style="display: flex; align-items: center">
        <div class="user-name">{{ user.first_name }} {{ user.last_name }}</div>
        <span v-if="isLeader" class="material-symbols-outlined crown-badge">
          crown
        </span>
      </div>
      <div class="user-email">{{ user.email }}</div>
      <div v-if="user.phone" class="user-phone">{{ user.phone }}</div>
    </div>
    <div class="user-tags">
      <div v-if="user.organization_name_current">
        <span class="tag tag-org">{{ user.organization_name_current }}</span>
        <span class="verified-badge" title="Verified">
          <span class="material-icons verified-icon">verified</span>
        </span>
      </div>
      <span v-else-if="user.organization_name" class="tag tag-org">
        {{ user.organization_name }}
      </span>
      <span v-if="user.dealer_name" class="tag tag-dealer">{{
        user.dealer_name
      }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({
  user: { type: Object, required: true },
});
const isLeader = computed(() => {
  return props.user.id === props.user.organization_owner_id;
});
</script>

<style scoped>
.user-card__header {
  padding: 0.75rem 0.9rem;
  gap: 0.55rem;
  font-size: 1.5rem;
  display: flex;
  justify-content: space-between;
  min-width: 30rem;
}
.user-ident {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.user-name {
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user-email {
  opacity: 0.8;
  font-size: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user-tags {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-end;
  justify-content: flex-start;
  height: 100%;
  color: white;
}
.tag {
  padding: 3px 6px;
  border-radius: 12px;
  font-size: 0.8rem;
  letter-spacing: 0.3px;
  line-height: 1;
  background: #2f2f2f;
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tag-org {
  background: #2c445c;
}
.tag-dealer {
  background: #513a66;
}
.verified-badge {
  color: #3aae49;
  margin-left: 0.5rem;
  vertical-align: middle;
}
.crown-badge {
  color: #eed444;
  margin-left: 0.5rem;
  vertical-align: middle;
}
.verified-icon {
  font-size: 1.2rem;
}
.user-phone {
  font-size: 0.65rem;
  opacity: 0.85;
  background: #2d2d2d;
  padding: 3px 6px;
  border-radius: 6px;
  width: fit-content;
  letter-spacing: 0.3px;
  color: white;
}
</style>
